import { Environment } from "./Environment";

export const ENV = {
    get: (key: string) => {
        const env = (window as any)["__env"];
        if (env !== undefined && env[key] !== undefined) {
            return env[key];
        }
        return null;
    },
};

export const env: Environment = {
    apiEndpoint: ENV.get("apiEndpoint") ?? "https://console.florencetelecom.net/agiCaller/api",
    apiVersion: ENV.get("apiVersion") ?? "v1",
    controllerUrl: ENV.get("controllerUrl") ?? "https://console.florencetelecom.net/api",
    controllerVersion: ENV.get("controllerVersion") ?? "v1",
    appRedirectLogin: ENV.get("appRedirectLogin") ?? "",
    production: true,
};

